const Footer = () => {
  return (
    <footer className="bg-white border-t">
      <div className="max-w-8xl mx-auto py-1 px-4 sm:px-6 lg:px-8">
        <p className="text-center text-sm text-gray-500">
          © {new Date().getFullYear()} Forex CRM. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
